<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td>
              Número
              <input
                type="text"
                class="form-control"
                id="numeroBusqueda"
                name="numeroBusqueda"
                v-model="numeroBusqueda"
                @keyup.enter="getDataNumero(1)"
                style="width: 120px; text-transform: uppercase"
                required
              />
            </td>
            <td>
              Cédula
              <input
                type="text"
                class="form-control"
                id="cedulaBusqueda"
                name="cedulaBusqueda"
                v-model="cedulaBusqueda"
                @keyup.enter="getDataCedula(1)"
                style="width: 120px; text-transform: uppercase"
                required
              />
            </td>
            <td>
              Nombre
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                @keyup.enter="getDataNombre(1)"
                style="width: 350px; text-transform: uppercase"
                required
              />
            </td>

            <td class="centro">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <!--                
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
-->
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
            <td>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <!--                
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
-->
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click="generarPlanillas"
                title="Generar Planillas"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                  >settings</i
                >Organizar Atenciones Médicas
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Número</th>
          <th scope="col">Nombre Paciente</th>
          <th scope="col">CodVal</th>
          <th scope="col">Cédula</th>
          <th scope="col">Diag1</th>
          <!--           <th scope="col">Diag2</th>
          <th scope="col">Diag3</th>
          <th scope="col">Diag4</th>
          <th scope="col">Diag5</th> -->
          <th scope="col">Motivo</th>
          <th scope="col">Tipo</th>
          <th scope="col">Fecha</th>
          <th scope="col">Hora Desde</th>
          <th scope="col">Hora Hasta</th>
          <!--           <th scope="col">Laboratorio01</th>
          <th scope="col">Laboratorio02</th>
          <th scope="col">Laboratorio03</th>
          <th scope="col">Laboratorio04</th>
          <th scope="col">Laboratorio05</th>
          <th scope="col">Laboratorio06</th>
          <th scope="col">Laboratorio07</th>
          <th scope="col">Laboratorio08</th>
          <th scope="col">Laboratorio09</th>
          <th scope="col">Laboratorio10</th>
          <th scope="col">Imagen01</th>
          <th scope="col">Imagen02</th>
          <th scope="col">Imagen03</th>
          <th scope="col">Imagen04</th>
          <th scope="col">Imagen05</th>
          <th scope="col">Imagen06</th>
          <th scope="col">Imagen07</th>
          <th scope="col">Imagen08</th>
          <th scope="col">Imagen09</th>
          <th scope="col">Imagen10</th>
          <th scope="col">TramiteFechaReg</th> -->
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cargaamb in datosPaginados" :key="cargaamb.idCargaAmb">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(cargaamb.idCargaAmb)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ cargaamb.numero }}</td>
          <td>{{ cargaamb.nombrePaciente }}</td>
          <td>{{ cargaamb.codVal }}</td>
          <td>{{ cargaamb.cedula }}</td>
          <td>{{ cargaamb.diag1 }}</td>
          <!--           <td>{{cargaamb.diag2}}</td>
          <td>{{cargaamb.diag3}}</td>
          <td>{{cargaamb.diag4}}</td>
          <td>{{cargaamb.diag5}}</td> -->
          <td>{{ cargaamb.motivo }}</td>
          <td>{{ cargaamb.tipo }}</td>
          <td>{{ getFormattedDate(cargaamb.fecha, "DD/MM/YYYY") }}</td>
          <td>{{ cargaamb.horaDesde }}</td>
          <td>{{ cargaamb.horaHasta }}</td>
          <!--           <td>{{cargaamb.laboratorio01}}</td>
          <td>{{cargaamb.laboratorio02}}</td>
          <td>{{cargaamb.laboratorio03}}</td>
          <td>{{cargaamb.laboratorio04}}</td>
          <td>{{cargaamb.laboratorio05}}</td>
          <td>{{cargaamb.laboratorio06}}</td>
          <td>{{cargaamb.laboratorio07}}</td>
          <td>{{cargaamb.laboratorio08}}</td>
          <td>{{cargaamb.laboratorio09}}</td>
          <td>{{cargaamb.laboratorio10}}</td>
          <td>{{cargaamb.imagen01}}</td>
          <td>{{cargaamb.imagen02}}</td>
          <td>{{cargaamb.imagen03}}</td>
          <td>{{cargaamb.imagen04}}</td>
          <td>{{cargaamb.imagen05}}</td>
          <td>{{cargaamb.imagen06}}</td>
          <td>{{cargaamb.imagen07}}</td>
          <td>{{cargaamb.imagen08}}</td>
          <td>{{cargaamb.imagen09}}</td>
          <td>{{cargaamb.imagen10}}</td>
          <td>{{getFormattedDate(cargaamb.tramiteFechaReg, 'DD/MM/YYYY')}}</td> -->
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteCargaAmb(cargaamb.idCargaAmb)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPaginaTodos(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- Bloque 1: Información Básica -->
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-3">Información Básica</h5>
                <div>
                  <button @click.prevent="mostrarOcultarBloque01">
                    {{
                      mostrarBloque01
                        ? "(-) Menos información"
                        : "(+) Más información"
                    }}
                  </button>
                </div>
              </div>
              <div v-if="mostrarBloque01" class="mb-3">
                <div class="row mb-3">
                  <div class="col-md-2">
                    <label for="idCargaAmb" class="form-label"
                      >ID Carga Ambulatoria</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="idCargaAmb"
                      name="idCargaAmb"
                      v-model="datoCargaAmb.idCargaAmb"
                      disabled
                    />
                  </div>
                  <div class="col-md-2">
                    <label for="numero" class="form-label">Número</label>
                    <input
                      type="text"
                      class="form-control"
                      id="numero"
                      name="numero"
                      v-model="datoCargaAmb.numero"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                  <div class="col-md-2">
                    <label for="cedula" class="form-label">Cédula</label>
                    <input
                      type="text"
                      class="form-control"
                      id="cedula"
                      name="cedula"
                      v-model="datoCargaAmb.cedula"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="nombrePaciente" class="form-label"
                      >Nombre del Paciente</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="nombrePaciente"
                      name="nombrePaciente"
                      v-model="datoCargaAmb.nombrePaciente"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Bloque 2: Diagnósticos -->
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-3">Diagnósticos</h5>
                <div>
                  <button @click.prevent="mostrarOcultarBloque02">
                    {{
                      mostrarBloque02
                        ? "(-) Menos información"
                        : "(+) Más información"
                    }}
                  </button>
                </div>
              </div>
              <div v-if="mostrarBloque02" class="mb-3">
                <div class="row">
                  <template v-for="i in 5" :key="'diag' + i">
                    <div class="col-md-2 mb-1">
                      <label :for="'diag0' + i" class="form-label"
                        >Diagnóstico {{ i }}</label
                      >
                    </div>
                    <div class="col-md-4 mb-1">
                      <input
                        type="text"
                        class="form-control"
                        :id="'diag0' + i"
                        :name="'diag0' + i"
                        v-model="datoCargaAmb['diag0' + i]"
                        style="text-transform: uppercase"
                        required
                      />
                    </div>
                  </template>
                </div>
              </div>
              <!-- Bloque 3: Laboratorios -->
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-3">Laboratorios</h5>
                <div>
                  <button @click.prevent="mostrarOcultarBloque03">
                    {{
                      mostrarBloque03
                        ? "(-) Menos información"
                        : "(+) Más información"
                    }}
                  </button>
                </div>
              </div>
              <div v-if="mostrarBloque03" class="mb-3">
                <div class="row">
                  <template v-for="i in 20" :key="'laboratorio' + i">
                    <div class="col-md-2 mb-1">
                      <label
                        :for="'laboratorio' + (i < 10 ? '0' + i : i)"
                        class="form-label"
                        >Laboratorio {{ i }}</label
                      >
                    </div>
                    <div class="col-md-4 mb-1">
                      <input
                        type="text"
                        class="form-control"
                        :id="'laboratorio' + (i < 10 ? '0' + i : i)"
                        :name="'laboratorio' + (i < 10 ? '0' + i : i)"
                        v-model="
                          datoCargaAmb['laboratorio' + (i < 10 ? '0' + i : i)]
                        "
                        style="text-transform: uppercase"
                        required
                      />
                    </div>
                  </template>
                </div>
              </div>
              <!-- Bloque 4: Imágenes -->
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-3">Imágenes</h5>
                <div>
                  <button @click.prevent="mostrarOcultarBloque04">
                    {{
                      mostrarBloque04
                        ? "(-) Menos información"
                        : "(+) Más información"
                    }}
                  </button>
                </div>
              </div>
              <div v-if="mostrarBloque04" class="mb-3">
                <div class="row">
                  <template v-for="i in 20" :key="'imagen' + i">
                    <div class="col-md-2 mb-1">
                      <label
                        :for="'imagen' + (i < 10 ? '0' + i : i)"
                        class="form-label"
                        >Imagen {{ i }}</label
                      >
                    </div>
                    <div class="col-md-4 mb-1">
                      <input
                        type="text"
                        class="form-control"
                        :id="'imagen' + (i < 10 ? '0' + i : i)"
                        :name="'imagen' + (i < 10 ? '0' + i : i)"
                        v-model="
                          datoCargaAmb['imagen' + (i < 10 ? '0' + i : i)]
                        "
                        style="text-transform: uppercase"
                        required
                      />
                    </div>
                  </template>
                </div>
              </div>
              <!-- Bloque 5: Detalles Adicionales -->
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-3">Detalles Adicionales</h5>
                <div>
                  <button @click.prevent="mostrarOcultarBloque05">
                    {{
                      mostrarBloque05
                        ? "(-) Menos información"
                        : "(+) Más información"
                    }}
                  </button>
                </div>
              </div>
              <div v-if="mostrarBloque05" class="mb-3">
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="fecha" class="form-label">Fecha</label>
                    <input
                      type="date"
                      class="form-control"
                      id="fecha"
                      name="fecha"
                      v-model="datoCargaAmb.fecha"
                      required
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="horaDesde" class="form-label">Hora Desde</label>
                    <input
                      type="time"
                      class="form-control"
                      id="horaDesde"
                      name="horaDesde"
                      v-model="datoCargaAmb.horaDesde"
                      required
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="horaHasta" class="form-label">Hora Hasta</label>
                    <input
                      type="time"
                      class="form-control"
                      id="horaHasta"
                      name="horaHasta"
                      v-model="datoCargaAmb.horaHasta"
                      required
                    />
                  </div>
                </div>
                <!--		  
          <div class="row mb-3">
            <div class="col-12">
              <label for="motivo" class="form-label">Motivo</label>
              <textarea
                class="form-control"
                id="motivo"
                name="motivo"
                v-model="datoCargaAmb.motivo"
                style="text-transform:uppercase"
              ></textarea>
            </div>
          </div>
-->
              </div>
            </div>
          </form>

          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarCargaAmb"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarCargaAmb"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import Swal from "sweetalert2";
export default {
  props: {
    p_idTramite: {
      type: Number,
      required: true,
    },
    p_idCarga: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      cargaambs: [],
      datoCargaAmb: {},
      numeroBusqueda: "",
      cedulaBusqueda: "",
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      tramites: [],
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
      mostrarBloque01: true,
      mostrarBloque02: true,
      mostrarBloque03: true,
      mostrarBloque04: true,
      mostrarBloque05: true,
    };
  },
  /*
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, 'dd/MM/yyyy');
    },
  },
*/

  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
  },
  methods: {
    mostrarOcultarBloque01() {
      this.mostrarBloque01 = !this.mostrarBloque01;
    },
    mostrarOcultarBloque02() {
      this.mostrarBloque02 = !this.mostrarBloque02;
    },
    mostrarOcultarBloque03() {
      this.mostrarBloque03 = !this.mostrarBloque03;
    },
    mostrarOcultarBloque04() {
      this.mostrarBloque04 = !this.mostrarBloque04;
    },
    mostrarOcultarBloque05() {
      this.mostrarBloque05 = !this.mostrarBloque05;
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.cargaambs.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwcargaambs/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.cargaambs = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.cargaambs.slice(ini, fin);
          });
      }
    },
    getDataNumero(noPagina) {
      if (this.numeroBusqueda != "") {
        api.get("/vwcargaambs/idtramite-numero/" +
              this.p_idTramite +
              "/" +
              this.numeroBusqueda
          )
          .then((response) => {
            this.cargaambs = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.cargaambs.slice(ini, fin);
          });
      }
    },
    getDataCedula(noPagina) {
      if (this.cedulaBusqueda != "") {
        api.get("/vwcargaambs/idtramite-cedula/" +
              this.p_idTramite +
              "/" +
              this.cedulaBusqueda
          )
          .then((response) => {
            this.cargaambs = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.cargaambs.slice(ini, fin);
          });
      }
    },
    getDataNombre(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwcargaambs/idtramite-nombre/" +
              this.p_idTramite +
              "/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.cargaambs = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.cargaambs.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwcargaambs/idtramite/" +
            this.p_idTramite
        )
        .then((response) => {
          this.cargaambs = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.cargaambs.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "idTramite",
        "numero",
        "nombrePaciente",
        "codVal",
        "cedula",
        "diag1",
        "diag2",
        "diag3",
        "diag4",
        "diag5",
        "motivo",
        "tipo",
        "fecha",
        "horaDesde",
        "horaHasta",
        "laboratorio01",
        "laboratorio02",
        "laboratorio03",
        "laboratorio04",
        "laboratorio05",
        "laboratorio06",
        "laboratorio07",
        "laboratorio08",
        "laboratorio09",
        "laboratorio10",
        "imagen01",
        "imagen02",
        "imagen03",
        "imagen04",
        "imagen05",
        "imagen06",
        "imagen07",
        "imagen08",
        "imagen09",
        "imagen10",
      ];
      const requiredFieldsText = [
        "idTramite",
        "numero",
        "nombrePaciente",
        "codVal",
        "cedula",
        "diag1",
        "diag2",
        "diag3",
        "diag4",
        "diag5",
        "motivo",
        "tipo",
        "fecha",
        "horaDesde",
        "horaHasta",
        "laboratorio01",
        "laboratorio02",
        "laboratorio03",
        "laboratorio04",
        "laboratorio05",
        "laboratorio06",
        "laboratorio07",
        "laboratorio08",
        "laboratorio09",
        "laboratorio10",
        "imagen01",
        "imagen02",
        "imagen03",
        "imagen04",
        "imagen05",
        "imagen06",
        "imagen07",
        "imagen08",
        "imagen09",
        "imagen10",
      ];
      return validarForm(this.datoCargaAmb, requiredFields, requiredFieldsText);
    },
    async guardarCargaAmb() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/cargaambs",
            this.datoCargaAmb
          );
          $("#ventanaModal").modal("hide");
          Swal("Correcto!", "CargaAmb creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
          window.location.reload();
        } catch (error) {
          Swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarCargaAmb() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/cargaambs",
            this.datoCargaAmb
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          Swal("Correcto!", "CargaAmb creado(a) exitosamente!", "success");
        } catch (error) {
          Swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => Swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoCargaAmb = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idCargaAmb) {
      this.modalWindow = true;
      if (idCargaAmb != null) {
        api.get("/vwcargaambs/" + idCargaAmb)
          .then((resp) => {
            this.datoCargaAmb = resp.data;
            this.datoCargaAmb.fecha = dateFormat.getFormattedDateISO(
              this.datoCargaAmb.fecha
            );
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idCargaAmb) {
      if (idCargaAmb != null) {
        this.$router.push("/cargaambmd/" + idCargaAmb);
      }
    },
    async deleteCargaAmb(idCargaAmb) {
      try {
        await api.delete("/cargaambs/" + idCargaAmb
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    async generarPlanillas() {
      try {
        Swal.fire({
          title: "Procesando...",
          text: "Por favor, espera mientras se organiza las atenciones.",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading(); // Muestra el indicador de carga
          },
        });
        await api.post(`/planillas/generar-planillas/${
            this.p_idTramite
          }/${window.sessionStorage.getItem("idUsuario")}`
        );
        Swal.close();
        Swal.fire({
          title: "¡Correcto!",
          text: "Atenciones generadas exitosamente.",
          icon: "success",
          confirmButtonText: "Aceptar",
        }).then(() => {
          window.location.reload();
        });
      } catch (error) {
        let mensajeError =
          "Ocurrió un problema inesperado. Inténtelo de nuevo.";

        if (error.response && error.response.data) {
          mensajeError = error.response.data.message || error.response.data;
        }

        Swal.fire({
          title: "¡Error!",
          text: mensajeError,
          icon: "error",
          confirmButtonText: "Cerrar",
        });
      }
    },
  },
};
</script>
